export type DepositDueWithinUnit = 'minutes' | 'hours' | 'days';

export const DEFAULT_REGULAR_DEPOSIT_DUE_VALUE = 60;
export const DEFAULT_REGULAR_DEPOSIT_DUE_UNIT: DepositDueWithinUnit = 'minutes';

export function normalizeDepositDueWithinUnit(raw: unknown): DepositDueWithinUnit {
  const unit = String(raw || '').trim().toLowerCase();
  if (unit === 'days' || unit === 'day') return 'days';
  if (unit === 'hours' || unit === 'hour') return 'hours';
  return 'minutes';
}

export function formatDepositDueDurationLabel(
  value?: number | null,
  unit?: string | null
): string {
  const safeValue =
    Number.isFinite(Number(value)) && Number(value) >= 1
      ? Math.round(Number(value))
      : DEFAULT_REGULAR_DEPOSIT_DUE_VALUE;
  const normalized = normalizeDepositDueWithinUnit(unit ?? DEFAULT_REGULAR_DEPOSIT_DUE_UNIT);
  if (normalized === 'days') {
    return `${safeValue} day${safeValue === 1 ? '' : 's'}`;
  }
  if (normalized === 'hours') {
    return `${safeValue} hour${safeValue === 1 ? '' : 's'}`;
  }
  return `${safeValue} minute${safeValue === 1 ? '' : 's'}`;
}
